import React from 'react';
import { coreValues } from '../data/mock';

const CoreValuesSection = () => {
  return (
    <section id="values" className="py-16 lg:py-24" style={{ background: 'linear-gradient(180deg, rgba(240, 228, 240, 0.3) 0%, rgba(255, 249, 242, 1) 100%)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-2 rounded-full text-sm font-medium mb-4" style={{ background: 'rgba(196, 165, 126, 0.2)', color: '#a88a5f' }}>
            Our Foundation
          </span>
          <h2 className="text-3xl sm:text-4xl font-display font-semibold mb-4" style={{ color: '#c49bc4' }}>
            Our Core Values C.A.R.E.
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Our core values guide all aspects of service delivery and define who we are.
          </p>
        </div>
        
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {coreValues.map((value, index) => (
            <div key={value.letter} className="value-card">
              <div className={`value-icon value-icon-${value.letter.toLowerCase()}`}>
                {value.letter}
              </div>
              <h3 className="text-xl font-semibold mb-3" style={{ color: '#008080' }}>
                {value.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoreValuesSection;